import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Component, DestroyRef, effect, HostListener, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { KEYCLOAK_EVENT_SIGNAL, KeycloakEventType } from 'keycloak-angular';
import { KeycloakService } from 'src/app/auth/keycloak.service';
import { KeycloakProfile } from 'keycloak-js';
import { SessionService } from '../../services/session.service';
import { LayoutService } from '../../../@vex/services/layout.service';
import { LogoutService } from '../../../@vex/services/logout.service';
import { FooterComponent } from '../footer/footer.component';
import { RouterLink, RouterOutlet } from '@angular/router';
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { NgStyle } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatListItem, MatListSubheaderCssMatStyler, MatNavList } from '@angular/material/list';
import { MatDivider } from '@angular/material/divider';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { MatIconButton } from '@angular/material/button';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	imports: [
		TranslocoDirective,
		FooterComponent,
		RouterOutlet,
		MatSidenavContent,
		NgStyle,
		MatIcon,
		MatListItem,
		MatDivider,
		MatNavList,
		MatToolbar,
		MatToolbarRow,
		MatSidenav,
		MatSidenavContainer,
		RouterLink,
		MatListSubheaderCssMatStyler,
		MatIconButton,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
	private readonly keycloak = inject(KeycloakService);
	private layoutService = inject(LayoutService);
	private logoutService = inject(LogoutService);
	sessionService = inject(SessionService);

	private destroyRef = inject(DestroyRef);
	private readonly keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);
	isLoggedIn = false;
	userProfile: KeycloakProfile | null = null;
	mobile = this.layoutService.isMobile();
	isSidebarOpen: boolean = true;
	contentMargin = 240;

	constructor() {
		this.isSidebarOpen = true;
		this.contentMargin = this.mobile ? 70 : 240;

		// keycloak-angular v22: events come from KEYCLOAK_EVENT_SIGNAL instead of the removed
		// keycloakEvents$ observable. Log out when the access token expires.
		effect(() => {
			if (this.keycloakSignal().type === KeycloakEventType.TokenExpired) {
				this.onLogout();
			}
		});
	}

	public async ngOnInit() {
		this.isLoggedIn = await this.keycloak.isLoggedIn();
		if (this.isLoggedIn) {
			this.userProfile = await this.keycloak.loadUserProfile();
		}
	}

	public onToolbarMenuToggle() {
		this.isSidebarOpen = !this.isSidebarOpen;
		this.resizeContent();
	}

	public onLogout() {
		this.logoutService.logout();
	}

	@HostListener('window:unload', ['$event'])
	unloadHandler(event) {
		// Do something when Window/Tab is closed
	}

	@HostListener('window:beforeunload', ['$event'])
	beforeUnloadHandler(event) {
		// Do something before Window/Tab is closed
	}

	private resizeContent() {
		if (this.mobile) {
			this.contentMargin = this.isSidebarOpen ? 70 : 0;
		} else {
			this.contentMargin = this.isSidebarOpen ? 240 : 70;
		}
	}
}
